import React, { memo } from 'react'
import { useCallback, useFormField } from 'sb-hooks'
import rest from 'redux/rest'
import type { Field } from 'sb-formx'

import SelectizeSearch from 'components/forms/selectize/SelectizeSearch/SelectizeSearch'

import FragranceSearchOption from './FragranceSearchOption/FragranceSearchOption'


export type FragranceSearchFieldProps = {
  className?: string
  field: Field
  placeholder?: string | ReactIntlMessage
}

const FragranceSearchField: React.FunctionComponent<FragranceSearchFieldProps> = (props) => {
  const { className, field, placeholder } = props

  const fetchOptions = useCallback((textValue) => (
    rest.models.fragrances.search(textValue)
      .then(({ suggestions }) => suggestions.map(
        (suggestion) => ({
          value: suggestion.data,
          title: suggestion.value,
          img: suggestion.img,
        })
      ))
      .catch((error) => {
        console.error(error)
        return []
      })
  ), [])

  const renderSearchOption = useCallback(({ img, title }, inputValue) => (
    <FragranceSearchOption title={title} img={img} query={inputValue} />
  ), [])

  const selectSearchOption = useCallback((option) => {
    field.set(option.value)
    field.validate()
  }, [ field ])

  const { error } = useFormField(field)

  return (
    <SelectizeSearch
      className={className}
      placeholder={placeholder}
      error={error}
      withSearchIcon
      fetchAction={fetchOptions}
      optionRender={renderSearchOption}
      onSelect={selectSearchOption}
    />
  )
}


export default memo(FragranceSearchField)
